/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { usePage } from '@api/hooks';
import { TextField, PageOrUrlField, ContentModuleModal, ColorField } from '@molecules';
import MediaField from '@organisms/MediaField';

import Form from '../Form';
import { FORM_FIELD } from './constants';
import Item from './Item';

const NewsletterSignup = ({
  visible,
  onSubmit,
  hide,
  previewImg,
  onDelete,
  initialValues: data = {},
  isUltimateDesign,
}) => {
  const [form] = Form.useForm(FORM_FIELD);
  const initialValues = React.useMemo(() => form.deserialize(data), [data, form]);
  const { page } = usePage({ id: data?.pageId });

  const pageOrUrlRef = React.useRef();

  React.useEffect(() => {
    if (visible) {
      form.setFieldsValue(
        page.id ? { [FORM_FIELD.BUTTON_URL.entityName]: page } : { [FORM_FIELD.BUTTON_URL.urlName]: data?.url },
      );
    }
  }, [form, page, visible, data]);

  const handleClose = React.useCallback(() => {
    form.resetFields();
    // see explanation in PageOrUrl field
    // eslint-disable-next-line no-unused-expressions
    pageOrUrlRef.current?.reset();

    hide();
  }, [form, hide]);

  const handleFinish = React.useCallback(
    async (values) => {
      onSubmit(values);
      handleClose();
    },
    [handleClose, onSubmit],
  );

  return (
    <ContentModuleModal
      visible={visible}
      title="Newsletter sign up"
      subtitle="Set up your newsletter details"
      okText={onDelete ? 'SAVE CHANGES' : 'ADD NEWSLETTER SIGN UP'}
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
    >
      <Form
        form={form}
        layout="vertical"
        wrapperCol={{ span: 24 }}
        initialValues={initialValues}
        onSerializedFinish={handleFinish}
      >
        {isUltimateDesign ? (
          <>
            <TextField {...FORM_FIELD.TITLE} />
            <TextField {...FORM_FIELD.DESCRIPTION} />
            <TextField {...FORM_FIELD.INPUT_NAME} />
            <TextField {...FORM_FIELD.INPUT_EMAIL} />
            <TextField {...FORM_FIELD.BUTTON_TEXT} />
            <ColorField {...FORM_FIELD.BACKGROUND_COLOUR} />
          </>
        ) : (
          <>
            <MediaField {...FORM_FIELD.IMAGE} />
            <TextField {...FORM_FIELD.TITLE} />
            <TextField {...FORM_FIELD.BUTTON_TEXT} />
            <PageOrUrlField ref={pageOrUrlRef} {...FORM_FIELD.BUTTON_URL} />
          </>
        )}
      </Form>
    </ContentModuleModal>
  );
};

NewsletterSignup.Item = Item;

export default NewsletterSignup;
